import React from 'react';

import { useStoreHoldsRow } from 'flow/components/nav/list-keys/row-index-store';
import ListItemSupervisor from 'flow/components/ui-components/ListItemSupervisor';
import useStableCallback from 'flow/hooks/useStableCallback';
import { ContactListItemData } from './contact-list-item-data';
import { CENTRAL_SWITCH_OVERVIEW_KEY } from './contact-list-rows';

interface Props {
    index: number;
    data: ContactListItemData;
}

// Like a contact, the row renders again only when its own props change.
const OverviewListItem = React.memo(ListItemSupervisor);

const CentralSwitchOverviewRow = ({ index, data }: Props) => {
    const isOpen = useStoreHoldsRow(data.openRowStore, data.rowKeys[index]);
    const onClick = useStableCallback(() =>
        data.onRowClick(index, CENTRAL_SWITCH_OVERVIEW_KEY, null, null),
    );

    return (
        <OverviewListItem
            marking={isOpen ? 'pageOpen' : undefined}
            onClick={onClick}
        />
    );
};

export default CentralSwitchOverviewRow;
